// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"h2-z"};